// Copyright (c) 2017 Deere & Company

import AuditStatusReport from '../../../reports/audit-status/state-connector';

export default {
    component: AuditStatusReport,
    name: 'AUDIT_STATUS',
    path: 'audit-status'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/audit-status.js